import React from 'react';
//importacion de todos los css segun su componente o contenedor.
import './Css/ItemListContainer.css'
// componente del menu de navegacion.
import NavBar from './components/navbar/NavBar';
//componente de banner de binvenida de la home.
import BannerIntro from './components/bannerIntro/BannerIntro';
//contenedor de lista de Productos.
import ItemListContainer from './container/ItemListContainer';
//contenedor del detalle de un producto.
import ItemDetailContainer from './container/ItemDetailContainer';
//componente banner de condiciones de compras.
import PieCatalogo  from './components/piecatalogo/PieCatalogo';
//componente footer de la web.
import Footer from './components/footer/Footer';
//componente de Error 404.
import PageError from './components/pageerror/PageError';
//componente de contacto que se envia via email.
import ContactUs from './components/contact/ContactUs';
//componente del carrito de compras.
import Cart from './components/cart/Cart';
import MyOrder from './components/Orders/MyOrder'
//dependencia para las rutas.
import {BrowserRouter, Switch, Route} from 'react-router-dom'

import {CartProvider} from './context/cartContext'
import UserProvider from './context/UserProvider';

// Iniciacion de ruta o navegacion de todo el proyecto

function App() {
  return (
    <UserProvider>
      <CartProvider>
        <BrowserRouter>
          <NavBar/>
            <Switch>
              <Route exact path='/order/:id'>
                <MyOrder/>
              </Route>
              <Route exact path='/category/:id'>
                <ItemListContainer />
              </Route>
              <Route exact path='/category'>
                <ItemListContainer/>
              </Route>
              <Route exact path='/item/:id'>
                <ItemDetailContainer/>
              </Route>
              <Route exact path='/contacto'>
                <ContactUs/>
              </Route>
              <Route exact path='/cart'>
                <Cart/>
              </Route>
                <Route exact path='/'>
                <BannerIntro greeting="Bienvenido a la tienda Online!"/>
                <ItemListContainer />
              </Route>
              <Route>
                <PageError/>
              </Route>
            </Switch>
          <PieCatalogo/>
          <Footer/>
        </BrowserRouter>
      </CartProvider>
    </UserProvider>  
  );

}

export default App;
